module.exports = __webpack_public_path__ + "static/media/Test25.226c276a.bmp";